import React from 'react'
import { Tooltip } from 'antd'
import { themeColor } from '@edulastic/colors'
import { IconCircleLogout, IconPearAssessLogoCompact } from '@edulastic/icons'
import styled from 'styled-components'
import { EduIf } from '@edulastic/common'
import { SaveAndExitButton } from '../../../assessment/themes/common/styledCompoenents'
import TimedTestTimer from '../../../assessment/themes/common/TimedTestTimer'

const SummaryHeader = ({
  hidePause,
  onExitClick,
  showExit,
  isTestPreviewModal = false,
  timedAssignment = false,
  // ASM-716 review/hub countdown is scoped to section-adaptive only
  isSectionAdaptiveTest = false,
  utaId,
  groupId,
}) => {
  const exitTestText = isTestPreviewModal ? 'Exit' : 'Save & Exit'
  return (
    <Header>
      <IconPearAssessLogoCompact
        style={{ fill: themeColor, marginLeft: '21px' }}
      />
      <HeaderRight>
        <EduIf condition={timedAssignment && isSectionAdaptiveTest && utaId}>
          <TimedTestTimer
            utaId={utaId}
            groupId={groupId}
            fgColor={themeColor}
          />
        </EduIf>
        {showExit ? (
          <Tooltip
            placement="bottom"
            title={
              hidePause
                ? 'This assignment is configured to completed in a single sitting'
                : exitTestText
            }
          >
            <SaveAndExitButton
              data-cy="finishTest"
              aria-label="Save and exit"
              onClick={onExitClick}
              style={{ border: '1px solid' }}
              disabled={hidePause}
            >
              <IconCircleLogout />
            </SaveAndExitButton>
          </Tooltip>
        ) : (
          // Keep the countdown where it sits in the question player (left of
          // Save & Exit), e.g. on final review where exit is not shown.
          timedAssignment &&
          isSectionAdaptiveTest &&
          utaId && <SaveAndExitSpacer aria-hidden />
        )}
      </HeaderRight>
    </Header>
  )
}

export default SummaryHeader

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 53px;
  border: 1px solid #dadae4;
  opacity: 1;
`

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  /* Match AssessmentPlayerDefault header horizontal padding (20px 30px). */
  padding-right: 30px;
`

/* Footprint of SaveAndExitButton (StyledButton) + its margin-left in the player. */
const SaveAndExitSpacer = styled.div`
  width: 40px;
  height: 40px;
  margin-left: 5px;
  flex-shrink: 0;
`
